import React, { useState } from 'react';
import { PaginationControlProps } from '../../../utils/interfaces';
import PaginationNextIcon from '../../../assets/svg/paginationNextIcon';

const PaginationControls = ({currentPage, setCurrentPage, itemsPerPage, setItemsPerPage, maxPages, formData}: PaginationControlProps) => {
  const [isHovered, setIsHovered] = useState(false);

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pages = [];
    const totalPages = maxPages;
    
    if (totalPages <= 7) {
      // Show all pages if 7 or fewer
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Show first page, current page range, and last page
      if (currentPage <= 4) {
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      }
    }
    
    return pages;
  };

  return (
    <div className="pagination-controls mt-3 d-flex justify-content-between align-items-center mb-0">
        <div className="" style={{width: '20%'}}>
            
            <span style={{fontSize: '1rem', }}>
                Showing <span className='mx-1' style={{
                    fontWeight: 'bold',
                }}>{(currentPage - 1) * itemsPerPage}</span> to {isHovered ? (
                    <select
                        value={itemsPerPage}
                        onChange={(e) => setItemsPerPage(Number(e.target.value))}
                        onMouseLeave={() => setIsHovered(false)}
                        onBlur={() => setIsHovered(false)}
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            padding: '2px 4px',
                            fontSize: '1rem',
                            backgroundColor: 'white',
                            cursor: 'pointer',
                            minWidth: '30px',
                            maxWidth: '50px'
                        }}
                        autoFocus
                    >
                        <option value={3}>3</option>
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={150}>150</option>
                        <option value={200}>200</option>
                        <option value={250}>250</option>
                    </select>
                ) : (
                    <span 
                        className='mx-1'
                        onMouseEnter={() => setIsHovered(true)}
                        style={{
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            textDecoration: 'underline',
                            color: '#005EEE'
                        }}
                    >
                        {currentPage * itemsPerPage}
                    </span>
                )} out
                of <span className='mx-1' style={{
                    fontWeight: 'bold',
                }}>{formData?.total_count || 0}</span> {formData?.total_count || 0 > 1 ? 'entries' : 'entry'}
            </span>

            
        </div>
        <div className="" style={{width: '40%', display: 'flex', justifyContent: 'end', alignItems: 'end'}}>
            
             {true && (
                 <>
                    <PaginationNextIcon 
                     className='mx-4 mb-1'
                     onClick={() => currentPage !== 1 && setCurrentPage(currentPage - 1)}
                     style={{
                         cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                         padding: "0px 0px",
                         transform: 'rotate(180deg)',
                         opacity: currentPage === 1 ? 0.3 : 1
                     }}
                 />
                    {/* <button
                        disabled={currentPage == 1}
                        onClick={() => setCurrentPage(currentPage - 1)}
                        className="btn btn-sm btn-primary"
                        style={{
                            width: "13%",
                            height: "3%",
                            padding: "0px 0px",
                        }}
                    >
                        &lt;
                    </button> */}
                     
                     {/* Page numbers */}
                     <div className="d-flex align-items-center gap-1">
                         {getPageNumbers().map((page, index) => (
                             <span key={index}>
                                 {page === '...' ? (
                                     <span style={{ padding: '4px 8px', color: '#666' }}>...</span>
                                 ) : (
                                     <button
                                         onClick={() => setCurrentPage(page as number)}
                                         className="btn btn-sm"
                                         style={{
                                             padding: '3px 8px',
                                             minWidth: '32px',
                                             backgroundColor: currentPage === page ? '#D9D9D9' : 'transparent',
                                             color: currentPage === page ? '#000' : '#005EEE',
                                             border: currentPage === page ? '1px solid transparent' : '1px solid transparent',
                                             borderRadius: '4px',
                                             fontSize: '0.75rem',
                                             fontWeight: currentPage === page ? 'bold' : 'normal',
                                             cursor: 'pointer',
                                             marginBottom: '5%',
                                             marginLeft: '3%',
                                             marginRight: '3%'
                                         }}
                                         onMouseEnter={(e) => {
                                             if (currentPage !== page) {
                                                 const target = e.target as HTMLButtonElement;
                                                 target.style.backgroundColor = '#f0f0f0';
                                             }
                                         }}
                                         onMouseLeave={(e) => {
                                             if (currentPage !== page) {
                                                 const target = e.target as HTMLButtonElement;
                                                 target.style.backgroundColor = 'transparent';
                                             }
                                         }}
                                     >
                                         {page}
                                     </button>
                                 )}
                             </span>
                         ))}
                     </div>
                     
                     &nbsp;

                    <PaginationNextIcon 
                         className='mx-4 mb-1'
                         onClick={() => !(currentPage >= maxPages) && setCurrentPage(currentPage + 1)}
                         style={{
                             cursor: currentPage >= maxPages ? 'not-allowed' : 'pointer',
                             padding: "0px 0px",
                             opacity: currentPage >= maxPages ? 0.3 : 1
                         }} 
                     />
                 </>
             )}
            
            {/* <label htmlFor="itemsPerPageSelect">Items per page:</label>
            <select
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                className="form-select mb-4"
                id="itemsPerPageSelect"
                aria-label="Items per page select"
            >
                <option value={3}>3</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={150}>150</option>
                <option value={200}>200</option>
                <option value={250}>250</option>
            </select> */}
        </div>
    </div>
  )
};

export default PaginationControls;